
// winOnresize
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import homeModal from "./home-modal.vue";
import maxNumber from "@/components/max-number/max-number.vue";

@Component({
  components: {
    "pi-home-modal": homeModal,
    "pi-max-number": maxNumber
  }
})
export default class PiHomeAssetInfo extends Vue {
  @Prop({
    default: "1"
  })
  private type = "1";
  @Prop({
    default: () => {
      return [];
    }
  })
  private list: objAny = [];
  private total = 0;
  private max = 0;
  @Watch("list")
  getTotal() {
    this.max = this.list.length ? this.list[0].value : 0;
    this.total = Number(
      this.list
        ?.map(item => item.value)
        .reduce((prev, cur) => {
          return prev + cur;
        }, 0)
        .toFixed(2)
    );
  }

  public getBai(value: number): string {
    if (value) {
      return ((value / this.max) * 100).toFixed(2) + "%";
    } else {
      return "0";
    }
  }
}
